import React from 'react';
import classNames from 'classnames';
import utils from '../../../../../utils/utils';
import { rateTemplate, shiftTypeTemplate, timePeriodTemplate } from '../../agency-utils';

import './ShiftDetails.scss';

const ShiftDetails = ({ shift, bundle }) => {
	const data = bundle || shift;
	return (
		<section className="shift-details-container modal-assign-professionals">
			<div className="shift-details-header">
				<h4>
					<span>{bundle !== null ? 'Bundle Details' : 'Shift Details'}</span>
				</h4>
			</div>
			<div className="shift-details-body">
				<div className="shift-details-row">
					<div className="shift-details-row-div col-50">
						<p className="shift-details-title">Facility</p>
						<p className="shift-details-text">{data.facility_name}</p>
					</div>
					<div className={classNames('shift-details-row-div', { 'col-25': bundle, 'col-50': shift })}>
						<p className="shift-details-title">Shift type</p>
						<div className="shift-details-text">{shiftTypeTemplate(data)}</div>
					</div>
					{bundle && (
						<div className="shift-details-row-div col-25">
							<p className="shift-details-title">Unit</p>
							<div className="shift-details-text">{data.unit}</div>
						</div>
					)}
				</div>
				<div className="shift-details-row">
					<div className="shift-details-row-div col-50">
						<p className="shift-details-title">Location</p>
						<div className="shift-details-text">
							{data.facility_address} <br />
							{data.facility_city}, {data.facility_state_code} {data.facility_zip_code}
						</div>
					</div>
					<div className="shift-details-row-div col-25">
						<p className="shift-details-title">Rate</p>
						{bundle ? (
							<div className="shift-details-text">
								<em>{utils.formatMoney(bundle.estimated_pay)} (estimate)</em>
							</div>
						) : (
							<div className="shift-details-text">
								{rateTemplate(data)}
								<br />
								<em>({utils.formatMoney(data.estimated_pay)} estimate)</em>
							</div>
						)}
					</div>
					{bundle ? (
						<div className="shift-details-row-div col-25">
							<p className="shift-details-title">Shifts</p>
							<div className="shift-details-text">{data.shift_count}</div>
						</div>
					) : (
						<div className="shift-details-row-div col-25">
							<p className="shift-details-title">Time</p>
							<div className="shift-details-text">{timePeriodTemplate(data)}</div>
						</div>
					)}
				</div>
			</div>
		</section>
	);
};

export default ShiftDetails;
